<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar card color="white">
            <v-text-field
              v-model="filters.match"
              :placeholder="$t('action.buttons.search')"
              flat
              solo
              prepend-icon="search"
              hide-details
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-2">
            <v-data-table
              item-key="_id"
              :headers="headers"
              :loading="loading"
              :items="items"
              :rows-per-page-items="[10, 25, 50]"
              disable-initial-sort
              :total-items="pagination.totalItems"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">
                  <v-avatar size="32">
                    <img :src="props.item.photo" alt />
                  </v-avatar>
                </td>
                <td>{{ props.item.name }}</td>
                <td>
                  <template v-if="props.item.entities">
                    <v-chip
                      v-for="(entity, index) of props.item.entities"
                      :key="index + entity.name"
                      small
                      color="transparent"
                    >
                      <v-avatar size="32">
                        <img :src="entity.logo" alt />
                      </v-avatar>
                      {{ entity.name }}
                    </v-chip>
                  </template>
                </td>
                <td>
                  <template v-if="props.item.teams">
                    <v-chip
                      v-for="(team, index) of props.item.teams"
                      :key="index + team.name"
                      small
                      color="transparent"
                    >
                      <v-avatar size="32">
                        <img :src="team.logo" alt />
                      </v-avatar>
                      {{ team.name }}
                    </v-chip>
                  </template>
                </td>
                <td v-if="type === 'push'" class="text-xs-center">
                  <button-state :state="props.item.read" />
                </td>
                <td v-else-if="type === 'email'" class="text-xs-center">
                  <button-state :state="props.item.readEmail" />
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from 'debounce'
import { apiAxios } from '@/helpers'

export default {
  name: 'TabReceivers',
  props: {
    notificationId: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    sendType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      filters: {
        type: this.type,
        sendType: this.sendType,
      },
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
      loading: false,
      intervalId: null,
    }
  },
  computed: {
    headers() {
      let headers = [
        {
          text: this.$t('fields.users.image'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$t('fields.notifications.entity'),
          value: 'entity',
        },
        {
          text: this.$t('fields.notifications.team'),
          value: 'team',
        },
      ]
      if (this.type === 'push') {
        headers.push({
          text: this.$t('fields.notifications.readPush'),
          align: 'center',
          value: 'read',
        })
      } else if (this.type === 'email') {
        headers.push({
          text: this.$t('fields.notifications.readEmail'),
          align: 'center',
          value: 'readEmail',
        })
      }

      return headers
    },
  },
  watch: {
    'filters.match': {
      handler: function () {
        if (this.pagination.page !== 1) this.pagination.page = 1
        this.debounceFetch()
      },
    },
    'pagination.page': {
      handler: function () {
        this.debounceFetch()
      },
    },
    'pagination.rowsPerPage': {
      handler: function () {
        this.debounceFetch()
      },
    },
    'pagination.sortBy': {
      handler: function () {
        this.debounceFetch()
      },
    },
    'pagination.descending': {
      handler: function () {
        this.debounceFetch()
      },
    },
  },
  created() {
    this.startInterval()
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    debounceFetch: debounce(function () {
      this.fetchData()
    }, 700),
    async fetchData() {
      try {
        this.loading = true
        let query = {
          page: this.pagination.page,
          limit: this.pagination.rowsPerPage,
        }
        let body = {}

        Object.keys(this.filters).forEach((key) => {
          if (
            this.filters[key] !== '' &&
            this.filters[key] !== undefined &&
            this.filters[key] !== null
          ) {
            body[key] = this.filters[key]
          }
        })
        if (this.pagination.sortBy) {
          query.sort = {
            [this.pagination.sortBy]: this.pagination.descending ? -1 : 1,
          }
        }
        const { data } = await apiAxios.post(
          `notifications/${this.notificationId}/receivers`,
          body,
          {
            params: { ...query },
          }
        )
        if (data.data) {
          this.items = data.data.users || []
          this.pagination.totalItems = data.paginate
            ? data.paginate.totalData
            : 0
        } else {
          this.items = []
        }
      } finally {
        this.loading = false
      }
    },
    startInterval() {
      this.intervalId = setInterval(() => {
        this.debounceFetch()
      }, 60 * 1000)
    },
  },
}
</script>
